export const ShipNavStatus = {
  Docked: 'DOCKED',
  InOrbit: 'IN_ORBIT',
  InTransit: 'IN_TRANSIT',
} as const satisfies Record<string, string>

export type ShipNavStatus = Values<typeof ShipNavStatus>

export const ShipFlightMode = {
  Cruise: 'CRUISE',
  Burn: 'BURN',
  Stealth: 'STEALTH',
  Drift: 'DRIFT',
} as const satisfies Record<string, string>

export type ShipFlightMode = Values<typeof ShipFlightMode>

export const WaypointTypes = {
  Planet: 'PLANET',
  GasGiant: 'GAS_GIANT',
  Moon: 'MOON',
  OrbitalStation: 'ORBITAL_STATION',
  JumpGate: 'JUMP_GATE',
  AsteroidField: 'ASTEROID_FIELD',
  Asteroid: 'ASTEROID',
  EngineeredAsteroid: 'ENGINEERED_ASTEROID',
  AsteroidBase: 'ASTEROID_BASE',
  Nebula: 'NEBULA',
  DebrisField: 'DEBRIS_FIELD',
  GravityWell: 'GRAVITY_WELL',
  ArtificialGravityWell: 'ARTIFICIAL_GRAVITY_WELL',
  FuelStation: 'FUEL_STATION',
} as const satisfies Record<string, string>

export type WaypointTypes = Values<typeof WaypointTypes>

export const WaypointTraits = {
  AshClouds: 'ASH_CLOUDS',
  Barren: 'BARREN',
  BlackMarket: 'BLACK_MARKET',
  BreathableAtmosphere: 'BREATHABLE_ATMOSPHERE',
  Bureaucratic: 'BUREAUCRATIC',
  Canyons: 'CANYONS',
  CommonMetalDeposits: 'COMMON_METAL_DEPOSITS',
  CorrosiveAtmosphere: 'CORROSIVE_ATMOSPHERE',
  Corrupt: 'CORRUPT',
  CrushingGravity: 'CRUSHING_GRAVITY',
  DebrisCluster: 'DEBRIS_CLUSTER',
  DeepCraters: 'DEEP_CRATERS',
  DiverseLife: 'DIVERSE_LIFE',
  DrySeabeds: 'DRY_SEABEDS',
  ExplorationOutpost: 'EXPLORATION_OUTPOST',
  ExplosiveGases: 'EXPLOSIVE_GASES',
  ExtremePressure: 'EXTREME_PRESSURE',
  ExtremeTemperatures: 'EXTREME_TEMPERATURES',
  Fossils: 'FOSSILS',
  Frozen: 'FROZEN',
  HighTech: 'HIGH_TECH',
  HollowedInterior: 'HOLLOWED_INTERIOR',
  IceCrystals: 'ICE_CRYSTALS',
  Industrial: 'INDUSTRIAL',
  Jovian: 'JOVIAN',
  Jungle: 'JUNGLE',
  MagmaSeas: 'MAGMA_SEAS',
  Marketplace: 'MARKETPLACE',
  MegaStructures: 'MEGA_STRUCTURES',
  MethanePools: 'METHANE_POOLS',
  MicroGravityAnomalies: 'MICRO_GRAVITY_ANOMALIES',
  MilitaryBase: 'MILITARY_BASE',
  MineralDeposits: 'MINERAL_DEPOSITS',
  MutatedFlora: 'MUTATED_FLORA',
  Ocean: 'OCEAN',
  Outpost: 'OUTPOST',
  Overcrowded: 'OVERCROWDED',
  PerpetualDaylight: 'PERPETUAL_DAYLIGHT',
  PerpetualOvercast: 'PERPETUAL_OVERCAST',
  PirateBase: 'PIRATE_BASE',
  PreciousMetalDeposits: 'PRECIOUS_METAL_DEPOSITS',
  Radioactive: 'RADIOACTIVE',
  RareMetalDeposits: 'RARE_METAL_DEPOSITS',
  ResearchFacility: 'RESEARCH_FACILITY',
  Rocky: 'ROCKY',
  SaltFlats: 'SALT_FLATS',
  ScarceLife: 'SCARCE_LIFE',
  ScatteredSettlements: 'SCATTERED_SETTLEMENTS',
  ShallowCraters: 'SHALLOW_CRATERS',
  Shipyard: 'SHIPYARD',
  SprawlingCities: 'SPRAWLING_CITIES',
  Stripped: 'STRIPPED',
  StrongGravity: 'STRONG_GRAVITY',
  StrongMagnetosphere: 'STRONG_MAGNETOSPHERE',
  Supervolcanoes: 'SUPERVOLCANOES',
  SurveillanceOutpost: 'SURVEILLANCE_OUTPOST',
  Swamp: 'SWAMP',
  Temperate: 'TEMPERATE',
  Terraformed: 'TERRAFORMED',
  ThinAtmosphere: 'THIN_ATMOSPHERE',
  ToxicAtmosphere: 'TOXIC_ATMOSPHERE',
  TradingHub: 'TRADING_HUB',
  Uncharted: 'UNCHARTED',
  UnderConstruction: 'UNDER_CONSTRUCTION',
  UnstableComposition: 'UNSTABLE_COMPOSITION',
  VastRuins: 'VAST_RUINS',
  VibrantAuroras: 'VIBRANT_AURORAS',
  Volcanic: 'VOLCANIC',
  WeakGravity: 'WEAK_GRAVITY',
} as const satisfies Record<string, string>

export type WaypointTraits = Values<typeof WaypointTraits>
